module.exports = __webpack_public_path__ + "img/pa-responsible-gambling.aa66f124.png";